"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsonPatch_1 = require("./jsonPatch");
var patches = __importStar(require("./patches"));
function inverse(p) {
    var pr = [];
    var skip = 0;
    for (var i = p.length - 1; i >= 0; i -= skip) {
        skip = invertOp(pr, p[i], i, p);
    }
    return pr;
}
exports.inverse = inverse;
function invertOp(patch, c, i, context) {
    switch (c.op) {
        case jsonPatch_1.OpType.Add:
            return patches[c.op].inverse(patch, c, i, context);
        case jsonPatch_1.OpType.Copy:
            return patches[c.op].inverse(patch, c, i, context);
        case jsonPatch_1.OpType.Move:
            return patches[c.op].inverse(patch, c, i, context);
        case jsonPatch_1.OpType.Remove:
            return patches[c.op].inverse(patch, c, i, context);
        case jsonPatch_1.OpType.Replace:
            return patches[c.op].inverse(patch, c, i, context);
        case jsonPatch_1.OpType.Test:
            return patches[c.op].inverse(patch, c, i, context);
        default:
            return 1;
    }
}
